document.addEventListener('DOMContentLoaded', function () {
  const isDesignMode = !!(window.Shopify && window.Shopify.designMode);
  const money = (n) => '$' + Number(n).toFixed(2);

  async function goWithDiscount(code, destination) {
    const target = destination || '/cart';
    if (!code) {
      window.location.href = target;
      return;
    }
    // Shopify's Cart AJAX API supports adding/removing a discount on the
    // current cart via /cart/update.js. This makes the discount part of the
    // actual cart state instead of changing only storefront text.
    const response = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({discount: code})
    });
    if (!response.ok) throw new Error('The selected bulk discount could not be applied. Check the discount code in Shopify.');
    const cart = await response.json();
    if (cart && cart.cart_level_discount_applications === undefined && cart.total_discount === 0) {
      // Shopify can legitimately return zero here for an inapplicable code;
      // do not silently pretend the discount worked.
      const applied = Array.isArray(cart.discount_codes) && cart.discount_codes.some(function(d){ return d.code && d.code.toLowerCase() === code.toLowerCase() && d.applicable; });
      if (!applied && Array.isArray(cart.discount_codes) && cart.discount_codes.length) {
        throw new Error('The selected bulk discount is not applicable to this cart.');
      }
    }
    window.location.href = target;
  }

  async function addItems(items) {
    const response = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items})
    });
    if (!response.ok) {
      let message = 'Unable to add this product to your cart.';
      try { const data = await response.json(); if (data.description) message = data.description; } catch(e) {}
      throw new Error(message);
    }
    return response.json();
  }

  // Homepage/product-card quick add.
  document.querySelectorAll('[data-add-to-cart]').forEach(function (button) {
    button.addEventListener('click', async function () {
      const id = Number(button.dataset.addToCart);
      if (!id) return;
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        await addItems([{id:id, quantity:1}]);
        window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
      } catch (error) {
        button.disabled = false;
        button.textContent = original;
        alert(error.message);
      }
    });
  });

  // Product page tier selector and real cart actions.
  document.querySelectorAll('[data-product-page]').forEach(function (page) {
    const box = page.querySelector('[data-volume-pricing]');
    const form = page.querySelector('[data-product-form]');
    if (!box || !form) return;

    const options = Array.from(box.querySelectorAll('.volume-option'));
    const qtyInput = page.querySelector('[data-volume-qty]');
    const variantInput = page.querySelector('[data-product-variant]');
    const total = box.querySelector('[data-volume-total]');
    const save = box.querySelector('[data-volume-save]');
    const addButton = page.querySelector('[data-product-add]');
    const buyButton = page.querySelector('[data-product-buy]');

    let selected = options[0];

    function selectOption(option) {
      selected = option;
      options.forEach(function (item) { item.classList.remove('is-selected'); });
      option.classList.add('is-selected');

      const qty = Number(option.dataset.qty);
      const unit = Number(option.dataset.unit);
      const saving = Number(option.dataset.save);
      if (qtyInput) qtyInput.value = qty;
      if (total) total.textContent = money(qty * unit);
      if (save) save.textContent = saving > 0 ? 'Save $' + Number(saving).toFixed(2) + '/ea' : '';
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () { selectOption(option); });
    });

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        const q = Math.max(1, Number(qtyInput.value) || 1);
        let match = options[0];
        options.forEach(function (option) {
          if (q >= Number(option.dataset.qty)) match = option;
        });
        selectOption(match);
        qtyInput.value = q;
      });
    }

    async function submitProduct(destination) {
      const variantId = Number(variantInput && variantInput.value);
      const quantity = Math.max(1, Number(qtyInput && qtyInput.value) || 1);
      if (!variantId) {
        alert('This product is unavailable.');
        return;
      }

      const original = destination === '/checkout' ? 'Buy Now' : 'Add to Cart';
      const button = destination === '/checkout' ? buyButton : addButton;
      if (button) { button.disabled = true; button.textContent = 'Adding…'; }

      try {
        await addItems([{id:variantId, quantity:quantity}]);
        let code = selected && selected.dataset ? selected.dataset.discount : '';
        const isMaxx = box.dataset.maxx === 'true';
        if (isMaxx) {
          const tierQty = Number(selected && selected.dataset ? selected.dataset.qty : quantity);
          if (tierQty >= 4) code = code || 'MAX4';
          else if (tierQty >= 3) code = code || 'MAX3';
          else if (tierQty >= 2) code = code || 'MAX2';
        } else {
          const tierQty = Number(selected && selected.dataset ? selected.dataset.qty : quantity);
          if (tierQty >= 6) code = code || 'PODS6';
          else if (tierQty >= 4) code = code || 'PODS4';
          else if (tierQty >= 3) code = code || 'PODS3';
        }
        await goWithDiscount(code, destination);
      } catch (error) {
        if (button) { button.disabled = false; button.textContent = original; }
        alert(error.message);
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submitProduct('/cart');
    });

    if (buyButton) {
      buyButton.addEventListener('click', function () { submitProduct('/checkout'); });
    }

    selectOption(options[0]);
  });

  // Cart quantity controls.
  document.querySelectorAll('[data-cart-quantity]').forEach(function (input) {
    input.addEventListener('change', async function () {
      const line = Number(input.dataset.cartLine);
      const quantity = Math.max(0, Number(input.value) || 0);
      if (!line) return;
      input.disabled = true;
      try {
        const response = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/change.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({line:line, quantity:quantity})
        });
        if (!response.ok) throw new Error('Cart update failed.');
        window.location.reload();
      } catch (error) {
        input.disabled = false;
        alert(error.message);
      }
    });
  });
});